<template>
  <div>
    <v-container class="mt-5">
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" xxl="6">
          <text-section
            heading="Tax Clearance Certificate"
            type="Tax Clearance Certificate"
          ></text-section>

          <SearchTextBox
            :action="verify"
            :vModel="searchText"
            type="TCC Number"
            :valueType="valueType"
          ></SearchTextBox>
          <v-alert dense outlined type="error" v-show="showAlert">{{
            errorMsg
          }}</v-alert>
        </v-col>
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="6"
          lg="6"
          xl="6"
          xxl="6"
          offset-xl="1"
          offset-xxl="1"
        >
          <div class="text-center">
            <v-overlay :value="overlay">
              <v-progress-circular
                indeterminate
                size="64"
              ></v-progress-circular>
            </v-overlay>
          </div>
          <div class=" " v-show="!isValidating" id="parent-element">
            <v-avatar
              v-if="tcc.tpImage && tcc.tpImage != null"
              id="taxpayer-image"
              height="120"
              width="120"
            >
              <v-img
                :src="`${rootAPI}/uploads/${tcc.tpImage}`"
                width="100%"
                height="100%"
              ></v-img>
            </v-avatar>
            <v-icon v-else color="green" size="100" id="check-box"
              >mdi-check</v-icon
            >
            <v-img
              class="d-none"
              id="account-icon"
              :src="require('../assets/board_logo.png')"
              width="100"
              height="50"
              contain
            ></v-img>

            <v-card dark class="mx-auto" id="black-card">
              <!-- <v-list-item two-line>
                <v-list-item-content> -->
              <!-- <v-list-item-title
                    class="headline mt-3 center-text border-none"
                    :class="{
                      'text-center': !tcc.tpImage && tcc.tpImage == null,
                    }"
                  >
                    <span
                      class="d-inline-block text-truncate text-lg"
                      style="max-width: 250px;"
                      >{{ tcc.certificateno }}</span
                    >
                  </v-list-item-title> -->
              <!-- <v-list-item-subtitle
                    :class="{
                      'text-center': !tcc.tpImage && tcc.Image == null,
                    }"
                    >{{ tcc.request_year }}</v-list-item-subtitle
                  > -->
              <!-- </v-list-item-content>
              </v-list-item> -->
              <!-- <v-divider></v-divider> -->

              <v-list-item
                class="h-[155px] w-full d-flex flex-column justify-start align-start pt-8"
              >
                <span
                  class="text-2xl font-weight-medium text-white w-8/12 md:w-9/12"
                >
                  {{ tcc.taxpayer }}
                </span>
                <span class="text-xs text-gray-300">{{
                  tcc.certificateno
                }}</span>
              </v-list-item>
              <v-divider></v-divider>

              <v-list-item class="flex justify-between md:py-1.5">
                <span class="text-sm text-gray-300 w-4/12">Year:</span>
                <span class="text-sm text-left pl-3 w-8/12 font-medium">{{
                  tcc.request_year
                }}</span>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item class="flex justify-between md:py-1.5">
                <span class="text-sm text-gray-300 w-4/12">Income Source:</span>
                <span class="text-sm text-left pl-3 w-8/12 font-medium">{{
                  tcc.income_source
                }}</span>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item class="flex justify-between md:py-1.5">
                <span class="text-sm text-gray-300 w-4/12">Expiry Date:</span>
                <span class="text-sm text-left pl-3 w-8/12 font-medium">{{
                  formatShortDate(tcc.expiration_date)
                }}</span>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item class="flex justify-between md:py-1.5">
                <span class="text-sm text-gray-300 w-4/12">Date Issued:</span>
                <span class="text-sm text-left pl-3 w-8/12 font-medium">{{
                  formatLongDate(tcc.issue_date)
                }}</span>
              </v-list-item>

              <v-list-item style="display: none;">
                <v-list-item-title>Income Source</v-list-item-title>
                <v-list-item-subtitle>{{
                  tcc.income_source
                }}</v-list-item-subtitle>
              </v-list-item>

              <v-divider></v-divider>
              <v-card-actions style="padding: 0 !important; overflow: hidden;">
                <details-modal class="view-details" :tcc="tcc">
                  View Details
                </details-modal>
              </v-card-actions>
            </v-card>
          </div>
          <side-image :isValidating="isValidating"></side-image>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import SideImage from "../components/side-image";
import TextSection from "../components/text-section";
import SearchTextBox from "../components/search-textbox";
import dayjs from "dayjs";
import DetailsModal from "../components/DetailsModal.vue";

let trimInput = (input) => {
  return input.replace(/^\s+|\s+$/gm, "");
};
export default {
  components: {
    SideImage,
    TextSection,
    SearchTextBox: SearchTextBox,
    DetailsModal,
  },
  data() {
    return {
      showAlert: false,
      isValidating: true,
      errorMsg: "",
      searchText: "",
      overlay: false,
      tcc: {},
      valueType: "String",
      rootAPI: "https://tcc.mekiotechdigital.com/api/tcc",
    };
  },
  methods: {
    formatShortDate(date) {
      return dayjs(date, "YYYY/MM/DD").format("dddd, MMMM D, YYYY");
    },
    formatLongDate(date) {
      return dayjs(date, "ddd, MMMM D, YYYY hh:mm:ss GMT").format(
        "dddd, MMMM D, YYYY"
      );
    },
    showError(msg) {
      this.errorMsg = msg;
      this.overlay = false;
      this.showAlert = true;
      this.isValidating = true;
      setTimeout(() => {
        const l = this.loader;
        this[l] = !this[l];

        this.showAlert = false;
      }, 2000);
    },
    verify(tccNumber) {
      this.isValidating = true;
      const api = `${this.rootAPI}/validate/`;
      let data = parseFloat(trimInput(tccNumber));
      if (data) {
        this.overlay = true;
        let vm = this;
        if (typeof data != "number") {
          this.showError(
            "Invalid Number Format. Note: Alphabets are not accepted"
          );
          return;
        }

        axios
          .post(api, {
            tccNumber: data,
          })
          .then(function(res) {
            if (res && res.data.code == 0) {
              setTimeout(() => {
                vm.isValidating = true;
                vm.showError(res.data.message);
              }, 1000);
            } else if (res && res.data.code == 1) {
              vm.tcc = res.data.data;
              setTimeout(() => {
                vm.isValidating = false;
                vm.overlay = false;
              }, 1000);
            }
          })
          .catch(function() {});
      } else {
        this.showError("Please enter a valid TCC number.", data);
      }
    },
  },
  created() {
    if (
      this.$route &&
      this.$route.name == "verify-tcc-by-route" &&
      this.$route.params
    ) {
      const id = this.$route.params.id;
      this.verify(id);
    }
  },
};
</script>
<style>
#parent-element {
  position: relative;
}
#check-box {
  position: absolute;
  z-index: 5;
  right: 1%;
  top: -40px;
}
#taxpayer-image {
  position: absolute;
  z-index: 5;
  right: 35px;
  top: 0px;
  border: 2px solid #3c3168;
}
@media screen and (max-width: 540px) {
  #taxpayer-image {
    position: absolute;
    z-index: 5;
    right: 0px;
    top: 0px;
  }
  #parent-element {
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
  }
}
@media screen and (min-width: 768px) {
  #taxpayer-image {
    position: absolute;
    z-index: 5;
    right: 0px;
    top: 0px;
  }
  #parent-element {
    max-width: 450px;
    margin-left: auto;
    margin-right: auto;
  }
}
@media screen and (min-width: 1180px) {
  #taxpayer-image {
    position: absolute;
    z-index: 5;
    right: 0px;
    top: 0px;
  }
  #parent-element {
    max-width: 450px;
  }
}
#account-icon {
  position: absolute;
  left: 6%;
  z-index: 5;
  top: -25px;
  color: #a8b8f1 !important;
}
#view-details {
  position: absolute;
  left: 6%;
  z-index: 5;
  bottom: 0;
  color: #a8b8f1 !important;
}
#black-card {
  position: relative;
  z-index: 1;
  background: #3c3168 !important;
  border-top-right-radius: 60px;
  border-top-left-radius: 50px;
  border-bottom-right-radius: 50px;
  border-bottom-left-radius: 50px;
}
h1 {
  color: #383838;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.2;
}
.v-input__icon .v-input__icon--append-outer .v-icon--link {
  font-size: 44px;
}
div.v-input__icon.v-input__icon--append-outer button.v-icon {
  color: black !important;
  background: #f2f8fe !important;
  padding: 16px 18px;
  border-radius: 0px 30px 30px 0px !important;
  margin-top: -6px;
}
div.v-input__slot {
  border: 3px solid #f2f8fe !important;
  border-radius: 30px 0 0 30px !important;
}
div.input__control {
  border: 3px soild green !important;
}
</style>
